
import Masking from '@/components/el-masking'
import GroupTransition from '@/components/el-group-transition'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


import {submitFeedback} from '@/api/system'

export default {
name: 'feedback-popup',
components: {Masking, XTextarea, XButton, GroupTransition, Group, Cell},
data() {
return {
focused: false,
show_form: !this.trigger,
submitting: false,
content: '',
placeholder: '点击输入您在使用班级助手遇到的问题，或者您 对班级助手的建议和意见。我们会及时解决您遇 到的问题，和听取您的每一条意见！'
}
},
props: {


trigger: {
type: Boolean,
default: true
}
},
computed: {
is_teacher_admin() {
return this.$store.getters.head_teacher_roles.length > 0
}
},
methods: {
goFaq(role) {
if (role == 'parents') {
this.$router.open('https://mp.weixin.qq.com/mp/homepage?__biz=MzI2MjI4MzI3MA==&hid=7&sn=c680290cb6fc8eb116a9b9d73945d7a9&devicetype=iOS12.1.4&version=1700032a&lang=zh_CN&nettype=3G+&ascene=1&fontScale=100&wx_header=1&scene=1')
} else {
this.$router.open('https://mp.weixin.qq.com/mp/homepage?__biz=MzI2MjI4MzI3MA==&hid=8&sn=56692496aaf647fcd44da08a9b2642a3&devicetype=iOS12.1.4&version=1700032a&lang=zh_CN&nettype=3G+&ascene=1&fontScale=100&wx_header=1&scene=1')
}
},
goJoinGroup() {
this.$router.open('https://aakit.cn/s/El86mpZJ9')
},
onFocus() {
this.focused = true
},
onBlur() {
this.focused = false
},
preventBlur(event) {
event.preventDefault()
},
onClose() {
this.show_form=false
this.$emit('close')
},
submitFeedback() {
if (!this.content) {
return this.$vux.toast.text('内容不可为空')
}

this.submitting = true
submitFeedback(this.content, process.env.WEB_ORIGIN + this.$route.fullPath, this.$route.meta.title)
.then((res) => {
this.submitting = false
if (res.code ==1) {
this.$vux.toast.text('发送成功,谢谢您的反馈建议:)')
this.show_form = false
this.content = ''
} else {
this.$vux.toast.text('提交失败: ' + res.message)
}
}).catch((e) => {
console.log(e)
this.submitting = false
this.$vux.toast.text('提交失败: ' + e.message)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/el-feedback-popup.vue